import React from 'react';
import Topbar from './Topbar/Topbar';
import MainContent from './MainContent/MainContent';
import Footer from './Footer/footer';
import './MainLayout.css';
import classNames from 'classnames';

const MainLayout = ({layoutType}) =>  {
    return (     
        <div className={classNames('workflow-main-layout', layoutType)}>
            <Topbar layoutType={layoutType} />                
            <MainContent layoutType={layoutType}/>
            <Footer />
        </div> 
    )
}

export default MainLayout
